import React from 'react';
import styled from 'styled-components';

import { LogoIcon } from 'components/Icons/LogoIcon';
import Loader from 'modules/corporateOffer/components/Loader';
import theme from 'theme/theme';

import {
  OnboardingSubtitle,
  OnboardingTitle,
} from './onboarding/StyledComponents';

type Props = {
  title: string;
  subtitle?: string;
};

const SuccessResult = ({ title, subtitle }: Props) => (
  <Container>
    <OnboardingTitle title={title} />
    {!!subtitle && <OnboardingSubtitle subtitle={subtitle} />}
    <LoaderContainer>
      <Loader bigCircleSize={183} smallCircleSize={139} />
      <LogoContainer>
        <LogoIcon width={80} height={50} fill={theme.colors.primary} />
      </LogoContainer>
    </LoaderContainer>
  </Container>
);

const LogoContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const LoaderContainer = styled.div`
  margin-top: 176px;
  position: relative;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 162px;
  }
`;

const Container = styled.article`
  margin: 0 auto;
`;

export default SuccessResult;
